var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9165 1.92655C11.9221 1.92818 11.9277 1.92993 11.9332 1.93181L12.7093 2.19554C12.8589 2.24637 12.9636 2.38263 12.969 2.54053C12.9729 2.65499 12.9749 2.76995 12.9749 2.88536C12.9749 8.36219 8.53502 12.802 3.0582 12.802C3.00577 12.802 2.95344 12.8016 2.90121 12.8008C2.77059 12.7988 2.65115 12.7283 2.58317 12.6167L1.94213 11.5649L1.94371 11.5651L1.17164 10.3264C0.9031 9.89557 1.01126 9.33064 1.41995 9.02947L3.41046 7.56263C3.67154 7.37023 4.01138 7.32069 4.31653 7.43055L6.58456 8.24704C7.41602 7.69909 8.11247 6.96291 8.61326 6.09918L7.70848 5.26196C7.39157 4.96872 7.30603 4.50161 7.49845 4.11509L8.68239 1.73685C8.89827 1.3032 9.40045 1.09463 9.86003 1.24775L11.9165 1.92655ZM11.805 3.12544L9.65152 2.40799L8.60778 4.5046L10.0955 5.70865L10.0933 5.71051L10.0978 5.71049C9.4349 7.3608 8.20849 8.72407 6.65673 9.56217L6.02988 9.28732L4.01901 8.5634L2.25689 9.86195L3.35911 11.6303C7.97265 11.4744 11.6805 7.74688 11.805 3.12544Z",
    fill: "#6E707A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8dcd170dac49c9b592ccc262c5301065.svg";
export { ForwardRef as ReactComponent };